<template>
  <div class='store'>
    <div class="kv-box">
      <img src="@/assets/serve/factory/store-kv.png" alt="" class="kv">
      <img src="@/assets/serve/factory/store-title.png" alt="" class="tittle">
      <div class="search-box">
        <Search :type="0" @areaForm="querymap"></Search>
      </div>
    </div>
    <div class="container">
      <div class="content">
        <div class="info" v-for="(item, index) in datalist" :key="index">
          <img :src="item.logo_url? item.logo_url : require('@/assets/serve/factory/default.png')" alt="" class="info-image">
          <div class="info-content">
            <div class="name">{{item.shop_name}}</div>
            <div class="number">
              <img src="@/assets/serve/factory/phone.png" alt="" class="phone">
              <span class="phone-font">{{item.shop_phone}}</span>
            </div>
            <div class="address">
              <img src="@/assets/serve/factory/location-min.png" alt="" class="location">
              <span class="address-name">{{item.shop_address}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import search from '@/components/citySearch.vue'
import { huntStore } from '@/api/store'
export default {
  name: 'Store',
  components:{ 
    Search:search
  },
  data() {
    return {
      datalist: []
    }
  },
  computed:{ },
  watch:{ },
  created() {
    this.querymap({
      province: '',
      city: '',
      data_type: 0
    })
  },
  mounted() {
      
  },
  methods: {
    querymap(form) {
      huntStore({
        ...form,
        data_type: 0
      }).then(res => {
        console.log(res.data)
        this.datalist = res.data
      })
    }
  }
}
</script>
<style lang='less' scoped>
.store {
  .kv-box {
    width: 100%;
    max-width: 1920px;
    position: relative;
    margin: 0 auto;
    .kv {
      width: 100%;
      vertical-align: middle;
    }
    .tittle {
      width: 391.5px;
      height: 177.5px;
      position: absolute;
      top: 111.5px;
      left: 50%;
      transform: translateX(-50%);
    }
    .search-box {
      width: 768px;
      height: 58px;
      position: absolute;
      top: 348px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 3;
    }
  }
  .container {
    width: 100%;
    min-height: 600px;
    max-width: 1920px;
    background: url('../../../assets/serve/factory/bg.png')no-repeat top center;
    background-size: 100% 100%;
    margin: 0 auto;
    .content {
      width: 1450px;
      margin: 0 auto;
      padding: 20px 0;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .info {
        width: 337px;
        height: 382px;
        background: #F2F2F2;
        box-shadow: 0px 0px 15px 0px rgba(153,153,153,0.47);
        border-radius: 16px;
        overflow: hidden;
        margin: 32px 32px 32px 0;
        &:nth-of-type(4n) {
         margin-right: 0; 
        } 
        .info-image {
          width: 100%;
          height: 200px;
          background: #FFFFFF;
          text-align: center;
          vertical-align: top;
          object-fit: contain;
        }
        .info-content {
          padding: 0 32px;
          height: 150px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          .name {
            padding: 10px 0 0 0;
            font-size: 18px;
            font-family: FZLanTingHeiS-DB-GB;
            font-weight: 400;
            color: #4E8B46;
            line-height: 28px;
            text-align: left;
          }
          .number {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            margin: 5px 0;
            .phone {
              width: 22px;
              height: 22px;
              vertical-align: top;
              margin-left: -5px;
            }
            .phone-font {
              font-size: 15px;
              font-family: FZLanTingHeiS-R-GB;
              font-weight: 400;
              color: #595858;
              text-align: left;
            }
          }
          .address {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            .location {
              width: 22px;
              height: 22px;
              vertical-align: top;
              margin-left: -5px;
            }
            .address-name {
              font-size: 15px;
              font-family: FZLanTingHeiS-R-GB;
              font-weight: 400;
              color: #595858;
              text-align: left;
            }
          }
        }
      }
    }
  }
}
</style>